import { render, staticRenderFns } from "./UpdateTenantInfo.vue?vue&type=template&id=ae97abc6&scoped=true"
import script from "./UpdateTenantInfo.vue?vue&type=script&lang=ts"
export * from "./UpdateTenantInfo.vue?vue&type=script&lang=ts"
import style0 from "./UpdateTenantInfo.vue?vue&type=style&index=0&id=ae97abc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae97abc6",
  null
  
)

export default component.exports